import { useMemo } from 'react';
import { useCategoryStore } from '../../hooks';

interface CategoryTabsProps {
  selectedCategoryId: string | null;
  onSelectCategory: (categoryId: string | null) => void;
}

interface TabItem {
  id: string;
  label: string;
  color?: string;
}

export function CategoryTabs({ selectedCategoryId, onSelectCategory }: CategoryTabsProps) {
  const { categories } = useCategoryStore();

  const tabs = useMemo(() => {
    const sortedCategories = [...categories].sort((a, b) => a.sortOrder - b.sortOrder);
    
    return sortedCategories.map((category): TabItem => ({
      id: category.id,
      label: category.icon ? `${category.icon} ${category.name}` : category.name,
      color: category.color,
    }));
  }, [categories]);

  const handleChange = (value: string) => {
    onSelectCategory(value || null);
  };

  const allTabs: TabItem[] = [{ id: '', label: 'Semua' }, ...tabs];

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {allTabs.map((tab) => {
        const isSelected = (selectedCategoryId || '') === tab.id;
        const category = categories.find(c => c.id === tab.id);
        const tabColor = category?.color || '#3B82F6';
        
        return (
          <button
            key={tab.id}
            onClick={() => handleChange(tab.id)}
            className={`
              flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium
              transition-all duration-200 whitespace-nowrap
              ${isSelected 
                ? 'text-white shadow-md' 
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }
            `}
            style={isSelected ? { backgroundColor: tabColor } : undefined}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
